import { useCallback, useRef, useState } from "react";

export const useVectorGridHover = () => {
  const hoveredElementRemovalTimeoutId = useRef();
  const [hoveredMapElementGeometryId, setHoveredMapElementGeometryId] = useState();

  const handleVectorGridHovered = useCallback(
    e => {
      const { id: mapElementGeometryId, hasTooltip } = e.layer.properties;

      // Ensure that the tooltip is not removed if the user moves the mouse inside an
      // element or between elements. This avoids tooltip flickering because of the
      // `MapElementsVectorGridTooltip` component that renders a hidden marker to display
      // the tooltip on.
      if (hoveredElementRemovalTimeoutId.current) {
        clearTimeout(hoveredElementRemovalTimeoutId.current);
        hoveredElementRemovalTimeoutId.current = null;
      }

      if (!hasTooltip || hoveredMapElementGeometryId === mapElementGeometryId) {
        setHoveredMapElementGeometryId(null);

        return;
      }

      setHoveredMapElementGeometryId(mapElementGeometryId);
    },
    [hoveredMapElementGeometryId]
  );

  const handleVectorGridHoveredOut = useCallback(() => {
    // If the user moves the mouse out of the hovered element, we want to remove the
    // tooltip, but only after a short delay to avoid flickering when the mouse moves
    // between elements or inside the same element.
    //
    // This allows the `handleVectorGridHovered` function to cancel the timeout if the
    // user moves the mouse over an element before the timeout is reached.
    hoveredElementRemovalTimeoutId.current = setTimeout(() => {
      hoveredElementRemovalTimeoutId.current = null;
      setHoveredMapElementGeometryId(null);
    }, 100);
  }, []);

  return {
    hoveredMapElementGeometryId,
    handleVectorGridHovered,
    handleVectorGridHoveredOut
  };
};
